import * as React from 'react';
import {
    List,
    Datagrid,
    TextField,
    TopToolbar,
    useRecordContext,
    useDataProvider,
    DataProviderContext,
} from 'react-admin';
import { LoadingSection } from '../../common/LoadingSection';
import { useParams } from 'react-router';
import Button from '@mui/material/Button';
import { Visibility } from '@mui/icons-material';
import { Student_Test_Mapping } from '../../custom';
import { NoDataSection } from '../../common/NoDataSection';
import FormattedDateTimeField from '../../common/FormattedDateTimeField';
import UserField from '../../common/UserField';
import { createCustomGoDataProvider } from '../../services';
import StudentResultModal from './StudentResultModal';
import { useState } from 'react';

const ListActions = () => {
    return <TopToolbar></TopToolbar>;
};

const ShowButton = ({ testId }: { testId: string }) => {
    const [open, setOpen] = useState(false);
    const record: Student_Test_Mapping = useRecordContext<Student_Test_Mapping>();
    const studentName = (record as any)?.student?.name || '';
    const isSubmitted = record?.status === 'SUBMITTED';
    return (
        <>
            {isSubmitted && (
                <>
                    <Button startIcon={<Visibility />} onClick={() => setOpen(true)}>
                        Result
                    </Button>
                    <StudentResultModal
                        open={open}
                        onClose={() => setOpen(false)}
                        testId={testId}
                        mappingId={record.id}
                        studentName={studentName}
                    />
                </>
            )}
        </>
    );
};

const StudentResponseList = () => {
    const { testId } = useParams();
    if (!testId) {
        return <LoadingSection />;
    }
    const baseDataProvider = useDataProvider();
    const customDataProvider = React.useMemo(
        () =>
            createCustomGoDataProvider(baseDataProvider, [
                {
                    resource: 'student_test_mapping',
                    apiEndpoint: `/test-series/test/${testId}/responses`,
                },
            ]),
        [baseDataProvider],
    );
    return (
        <DataProviderContext.Provider value={customDataProvider}>
            <List
                title={<StudentResponseListTitle />}
                empty={<NoDataSection resource={'student_test_mapping'} />}
                sort={{ field: 'started_at', order: 'DESC' }}
                resource={'student_test_mapping'}
                actions={<ListActions />}
            >
                <Datagrid bulkActionButtons={false}>
                    <UserField source="student" />
                    <TextField source="status" />
                    <FormattedDateTimeField source="startedAt" />
                    <FormattedDateTimeField source="submittedAt" />
                    <FormattedDateTimeField source="endTime" />
                    <FormattedDateTimeField source="createdAt" />
                    <ShowButton testId={testId} />
                </Datagrid>
            </List>
        </DataProviderContext.Provider>
    );
};

const StudentResponseListTitle = () => {
    return <span className="flex flex-row items-center">{'Student Responses'}</span>;
};

export default StudentResponseList;
